import {PermitWorkFlow} from './PermitWorkFlow'

export class PermitWorkflowViewModel {
    PermitWorkFlows: PermitWorkFlow[];
    Export: boolean;
    SaveSubmit: boolean;
    ApproveReject: boolean;
    Close: boolean;
    User:boolean
}